import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export default function LanguageSwitcher({ className = '', variant = 'light' }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const next = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(next);
  };

  const isDark = variant === 'dark';

  return (
    <button
      onClick={toggleLanguage}
      className={`
        btn-press px-3 py-1.5 rounded-lg text-sm font-semibold border whitespace-nowrap cursor-pointer
        ${isDark
          ? 'bg-foreground-800 text-background-50 border-foreground-700 hover:bg-foreground-700'
          : 'bg-background-100 text-foreground-700 border-background-200 hover:bg-background-200'
        }
        ${className}
      `}
      title={i18n.language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
    >
      {i18n.language === 'ar' ? t('lang.en') : t('lang.ar')}
    </button>
  );
}